export default __webpack_public_path__ + "static/media/ZitelPromotion-1404.958ce5e2.jpg";